// ─────────────────────────────────────────────────────────────────────────────
// Aplica a i18next el idioma ya resuelto del usuario (`demoUser.idioma`).
//
// POR QUÉ ES UN HOOK Y NO UN `useEffect` SUELTO. Vivía embebido en `App.tsx`, que es el armazón
// del PORTAL. La zona `/app/…` (el Programa de Reconocimiento completo) monta su propio armazón
// —`router/AppLayout.tsx`— y por tanto nunca ejecutaba ese efecto: i18next se quedaba con lo que
// hubiera detectado el `LanguageDetector` (localStorage o el idioma del navegador) e ignoraba por
// completo la preferencia del usuario. Con el navegador en inglés, un usuario cuyo perfil dice
// español veía Reconocer, Brillamos y Perfil en inglés.
//
// La precedencia completa (locale de Teams > preferredLanguage del perfil > idioma del navegador >
// español) ya la resuelve `resolveInitialLanguage` en `UserContext`. Aquí solo se aplica.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '@/contexts/UserContext';
import { SUPPORTED_LANGUAGE_CODES } from '@/i18n/languages';

/** Sincroniza `demoUser.idioma` con i18next. Debe usarse DENTRO de `UserProvider`. */
export function useAppLanguage(): void {
  const { i18n } = useTranslation();
  const { demoUser } = useUserContext();

  useEffect(() => {
    if (
      demoUser.idioma
      && SUPPORTED_LANGUAGE_CODES.includes(demoUser.idioma)
      && demoUser.idioma !== i18n.language
    ) {
      // `changeLanguage` devuelve una promesa que nadie espera; si falla, el idioma anterior sigue
      // siendo válido, así que se traga el rechazo en vez de dejarlo sin capturar.
      i18n.changeLanguage(demoUser.idioma).catch(() => { /* se conserva el idioma actual */ });
    }
  }, [demoUser.idioma, i18n]);
}
